if (typeof loadeMoreSlider_G === 'undefined') {
	globalThis.loadeMoreSlider_G = null;
}

(function () {
	/* Productive #314 (round 2, iPhone Safari): a card slider inside a section
	   carousel is built only once its card comes within 300px of the viewport.
	   The homepage at 390 carried 100 of these (50 per carousel), each a full
	   Swiper with a MutationObserver, a ResizeObserver and 4-7 image slides -
	   108 Swiper instances and ~13k DOM nodes before the shopper touched
	   anything. On an iPhone that load delays touch events during a drag, so
	   Swiper timed a quick flick as a slow one and, because the finger had not
	   travelled half a card, snapped the row back - the "glitchy" swipe. Inside
	   a carousel a card slider is only ever driven by its arrows / dots (touch
	   is off there, see allowTouchMove below), so building it late costs
	   nothing visible: the first image is the slide that shows unbuilt, and the
	   dots + arrows appear as the card scrolls into view. PLP / search /
	   recommendation cards keep building immediately - their toolbar toggle
	   (plp-shot-toggle) drives every card slider at once. */
	let deferredObserver = null;
	const deferSlider = (slider, build) => {
		if (slider.dataset.sliderDeferred) return;
		slider.dataset.sliderDeferred = "1";
		if (!("IntersectionObserver" in window)) {
			build();
			return;
		}
		if (!deferredObserver) {
			deferredObserver = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (!entry.isIntersecting) return;
						deferredObserver.unobserve(entry.target);
						const pending = entry.target.__buildSlider;
						delete entry.target.__buildSlider;
						if (pending && !entry.target.swiper) pending();
					});
				},
				{ rootMargin: "300px 300px" },
			);
		}
		slider.__buildSlider = build;
		deferredObserver.observe(slider);
	};

	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");
		const dir = document.querySelector('html').getAttribute("dir");

		let nextEl = ".product-button-group .swiper-button-next";
		let prevEl = ".product-button-group .swiper-button-prev";
		if (dir === 'rtl') {
			[nextEl, prevEl] = [prevEl, nextEl];
		}
		const initialisedSliders = [];

		sliders.forEach((slider, index) => {
			if (slider?.swiper) return;

			// QA #184 / #185: card-level swiping is switched off for cards that sit INSIDE a
			// section carousel, and left on everywhere else (PLP grid, search, recommendations).
			// Both tickets report the same thing: on a phone the horizontal gesture over a card
			// image was consumed by this inner slider, so the outer track only moved when the
			// touch happened to land in the ~20px gutter between cards, and a gesture the inner
			// slider had partly recognised resolved as a tap on the card's overlay link.
			//
			// `nested: true` below was the previous attempt at this and is not sufficient on its
			// own: it releases the gesture to the parent only once the inner slider has run out
			// of slides to travel, so the first one or two swipes are still eaten. Inside a
			// carousel the row IS the primary gesture, so the inner slider gives it up entirely
			// rather than competing for it.
			//
			// Scoped by ancestor, not by viewport - the existing `breakpoints.990` rule already
			// handles "no card dragging at desktop", and PLP cards must keep swiping at mobile.
			//
			// Detected by looking for ANY Swiper ancestor rather than by listing section
			// classes: cards sit inside a horizontal track in product-carousel
			// (.js-swiper-product-carousel), product-slider (.product-slider__product-swiper)
			// and recommendations (.js-recommendation-swiper), and a generic check keeps new
			// carousels working without anyone remembering to update a list here. The card's
			// own root carries `.swiper`, hence closest() from the parent, not the slider.
			const inSectionCarousel = !!slider.parentElement?.closest(".swiper");

			const buildSlider = () => {
				const productSlider = new Swiper(slider, {
					pagination: {
						el: ".product-pagination .swiper-pagination",
						clickable: true,
					},
					navigation: {
						nextEl: nextEl,
						prevEl: prevEl,
					},
					// This slider lives INSIDE the section carousels (.js-swiper-product-carousel
					// et al), so a horizontal touch on a card image is seen by both swipers. With
					// nested unset (false), the inner one swallowed the gesture and the outer
					// track barely moved — the reported "can't swipe past 1-2 products before it
					// goes to a link". `nested: true` makes the inner slider release the gesture
					// to its parent once it has no further slide to travel, which is what lets the
					// row keep scrolling while card-level swiping still works.
					nested: true,
					allowTouchMove: !inSectionCarousel,
					// Productive #233 - the card's image arrows wrap: next on the last shot
					// returns to the first. `rewind` rather than `loop` so slide positions
					// stay real (the PLP model/product toggle addresses slide 0 / 1).
					rewind: true,
					// Was a bare `990:` key sitting directly on the options object, which Swiper
					// never reads — it only honours width keys inside `breakpoints`, so the intent
					// (no card-level dragging at desktop, where hover + arrows take over) was a
					// silent no-op and touch stayed enabled at every width.
					breakpoints: {
						990: {
							allowTouchMove: false,
						},
					},
					// Desktop image-clip bug: this script runs synchronously (deferred, but before
					// the outer product-carousel Swiper's DOMContentLoaded init in
					// section-product-carousel.js), and again before a tab panel's `.hidden` class
					// is ever removed. Either way this slider can measure its width before its
					// ancestor (carousel slide / tab panel) has settled into its final size, then
					// never re-measures — clipping every slide after the first. observer +
					// observeParents make it auto-update whenever an ancestor's class/style mutates.
					observer: true,
					// Productive #314: NOT inside a section carousel. observeParents watches
					// every ancestor's attributes, and the outer track writes its transform
					// to its wrapper on each touchmove - so a single swipe over a 50-card
					// homepage carousel fired update() on all 50 card sliders ~25 times each
					// (1,250+ full re-measures per gesture, measured at 390), which is the
					// stutter the client filmed. Card sliders in a carousel cannot be dragged
					// anyway (allowTouchMove above), and the two cases observeParents covered
					// - a tab panel un-hiding, and layout settling after load - are already
					// re-measured explicitly by section-product-carousel.js (tab click) and
					// the window load handler below. PLP / search / recommendation cards keep
					// it: their ancestors do not animate.
					observeParents: !inSectionCarousel,
				});

				initialisedSliders.push(productSlider);
			};

			if (inSectionCarousel) {
				deferSlider(slider, buildSlider);
			} else {
				buildSlider();
			}
		});

		// Same settling concern as the carousel's outer Swiper (see the "Panel-1-class bug"
		// comment in section-product-carousel.js) - re-measure once everything has actually
		// finished loading, in case a mutation happened before the observer attached.
		window.addEventListener("load", () => {
			initialisedSliders.forEach((productSlider) => productSlider.update());
		});
	};

	initSlider();
	loadeMoreSlider_G = initSlider;

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();
